import "./WordFieldCharCount.css";
import { visibleLength, WORD_TEXT_MIN_VISIBLE } from "../utils/wordSanitize";

export default function WordFieldCharCount({ value, maxLength }) {
  const count = String(value || "").length;
  const inRange =
    visibleLength(value) >= WORD_TEXT_MIN_VISIBLE && count <= maxLength;
  return (
    <span className="word-field-char-count">
      <span
        className={`word-field-char-count__current${
          inRange ? "" : " word-field-char-count__current--short"
        }`}
      >
        {count}
      </span>
      {" / "}
      <span className="word-field-char-count__max">{maxLength}</span>
    </span>
  );
}
